<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn text class="mx-auto pa-1" v-on="on">My roommate is not on this list</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline mx-auto">Invite your Roommate to EDUrent</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <form @submit.prevent="send">
            <v-col cols="12">
              <v-row class="justify-center px-4">
                <v-text-field outlined placeholder="Name"
                  v-model="user.name"
                  :error-messages="nameErrors"
                  @input="$v.user.name.$touch()"
                  @blur="$v.user.name.$touch()"
                />
              </v-row>
              <v-row class="justify-center px-4">
                <v-text-field outlined placeholder="E-mail Address"
                  v-model="user.email"
                  :error-messages="emailErrors"
                  @input="$v.user.email.$touch()"
                  @blur="$v.user.email.$touch()"
                />
              </v-row>
              <v-row class="justify-center px-4">
                <v-btn large color="primary mr-4" type="submit" :loading="isLoading">Submit</v-btn>
              </v-row>
            </v-col>
          </form>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import UserService from "../services/user.service";

export default {
  name: 'NewRoommateDialog',

  validations: {
    user: {
      name: { required },
      email: { required, email }
    }
  },

  data() {
    return {
      dialog: false,
      isLoading: false,
      user: {
        name: '',
        email: ''
      }
    }
  },

  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.user.name.$dirty) return errors
      !this.$v.user.name.required && errors.push('Name is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.user.email.$dirty) return errors
      !this.$v.user.email.email && errors.push('Must be valid e-mail')
      !this.$v.user.email.required && errors.push('E-mail is required')
      return errors
    }
  },

  methods: {
    async send() {
      this.$v.user.$touch();
      if (this.$v.user.$invalid) {
        this.$store.commit('setSnackbar', {
            show: true,
            message: 'Mandatory field(s) required for invite roommate are missing',
            color: 'red'
        });

        return;
      }

      let hasErrors = false;
      this.isLoading = true;
      await UserService.inviteRoommate(this.user).catch(() => {
          hasErrors = true;
      });
      this.isLoading = false;
      if (hasErrors) {
        return;
      }

      await this.$nextTick();
      this.dialog = false;
    }
  }
}
</script>

<style scoped>
form {
  width: 100%;
}
</style>
